import { post } from "../utilities/http";
import { AUTH_BASE_URL } from "../utilities/urls";

/**
 * Login
 * @return {Promise<any>}
 */
export function login(data: IAuth): Promise<any> {
  return post(`${AUTH_BASE_URL}/login`, data);
}

export function register(data: IAuth): Promise<any> {
  return post(`${AUTH_BASE_URL}/register`, data);
}

export function logout(): Promise<any> {
  return post(`${AUTH_BASE_URL}/logout`, {});
}

interface IAuth {
  email: string;
  password: string;
}
